import { cn } from '@heidi/utils';

/**
 * DS-1202 experimental Progress recipe, behind
 * `release-experimental-design-system-forms`. Only the indicator changes
 * colour; the track keeps `bg-background-secondary` (a neutral, not a tone).
 *
 * The indicator takes `semantic-fill-success` — the tone role for objects that
 * carry nothing on top, so the pairing that matters is against the surface
 * behind them (3:1, WCAG 1.4.11). It measures 3.14:1 on the track in newBrand
 * and 3.97:1 in newBrandDark.
 *
 * Not `semantic-background-*`: that is the *soft* tone surface (forest/50
 * newBrand, forest/950 newBrandDark), ~1.1:1 against the track — an invisible
 * bar. Not `button-background-*` / `toast-background-*` either: those are
 * container fills sized to clear their own label (4.5:1 and 3:1 respectively),
 * and a progress bar has no label on it.
 *
 * This is also an accessibility fix: the stable recipe's
 * `bg-validation-success` (lime/600) measures 2.55:1 on the newBrand track and
 * fails 1.4.11 today.
 */
export const progressIndicatorClassesExperimental = cn(
  'size-full flex-1 bg-semantic-fill-success transition-all'
);
